import { render } from "./ButtonMove.vue?vue&type=template&id=0c459eff&scoped=true"
import script from "./ButtonMove.vue?vue&type=script&lang=js"
export * from "./ButtonMove.vue?vue&type=script&lang=js"

import "./ButtonMove.vue?vue&type=style&index=0&id=0c459eff&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c459eff"]])

export default __exports__